document.addEventListener('DOMContentLoaded', () => {
  initZaisFunnelHeroes();
  deferZaisFunnelFaq();
});

function initZaisFunnelHeroes() {
  document.querySelectorAll('[data-zais-funnel-hero]').forEach((root) => {
    if (root.dataset.zaisFunnelHeroInitialized === 'true') return;
    root.dataset.zaisFunnelHeroInitialized = 'true';

    const dataNode = root.querySelector('[data-zais-funnel-hero-data]');
    if (!dataNode) return;

    const data = JSON.parse(dataNode.textContent);
    const formatPrice = data.currency
      ? (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: data.currency,
        }).format(cents / 100)
      : formatMoney;
    const state = {
      purchaseType: data.hasSellingPlans ? 'subscription' : 'one-time',
      variantId: data.initialVariantId,
    };

    const elements = {
      gallery: root.querySelector('[data-zais-product-gallery]'),
      variantInput: root.querySelector('.product-variant-id'),
      quantityInput: root.querySelector('[data-zais-funnel-quantity-input]'),
      priceCurrent: root.querySelector('[data-zais-funnel-price-current]'),
      priceOriginal: root.querySelector('[data-zais-funnel-price-original]'),
      priceSave: root.querySelector('[data-zais-funnel-price-save]'),
      priceNote: root.querySelector('[data-zais-funnel-price-note]'),
      sizeLabel: root.querySelector('[data-zais-funnel-size-label]'),
      sellingPlanSelect: root.querySelector('[data-zais-funnel-selling-plan]'),
      sellingPlanWrap: root.querySelector('[data-zais-funnel-selling-plan-wrap]'),
      subscriptionCopy: root.querySelector('[data-zais-funnel-subscription-copy]'),
      form: root.querySelector('[data-zais-funnel-form]'),
    };

    const variantButtons = [...root.querySelectorAll('[data-zais-funnel-variant-button]')];
    const purchaseButtons = [...root.querySelectorAll('[data-zais-funnel-purchase]')];
    const galleryThumbs = [...root.querySelectorAll('[data-zais-gallery-thumb]')];
    const galleryPreviousButtons = [...root.querySelectorAll('[data-zais-gallery-previous]')];
    const galleryNextButtons = [...root.querySelectorAll('[data-zais-gallery-next]')];
    const tabButtons = [...root.querySelectorAll('[data-zais-funnel-tab-button]')];
    const tabPanels = [...root.querySelectorAll('[data-zais-funnel-tab-panel]')];

    const variantMap = new Map(data.variants.map((variant) => [String(variant.id), variant]));
    const getVariantDisplayTitle = (variant) => {
      const title = variant.publicTitle || variant.title;
      return !title || title === 'Default Title' ? 'One size' : title;
    };

    const updatePurchaseButtons = () => {
      purchaseButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.purchaseType === state.purchaseType);
      });
    };

    const updateTabs = (tabId) => {
      tabButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.zaisFunnelTabButton === tabId);
      });
      tabPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.zaisFunnelTabPanel === tabId);
      });
    };

    const getActiveSellingPlan = (variant) => {
      if (!variant || !variant.sellingPlans.length || state.purchaseType !== 'subscription') return null;

      const currentValue = elements.sellingPlanSelect?.value;
      return (
        variant.sellingPlans.find((plan) => String(plan.id) === currentValue) ||
        variant.sellingPlans[0]
      );
    };

    const populateSellingPlans = (variant) => {
      if (!elements.sellingPlanSelect || !elements.sellingPlanWrap) return;

      if (state.purchaseType !== 'subscription' || !variant.sellingPlans.length) {
        elements.sellingPlanWrap.hidden = true;
        elements.sellingPlanSelect.innerHTML = '';
        elements.sellingPlanSelect.disabled = true;
        return;
      }

      elements.sellingPlanWrap.hidden = false;
      elements.sellingPlanSelect.disabled = false;
      elements.sellingPlanSelect.innerHTML = variant.sellingPlans
        .map(
          (plan) =>
            `<option value="${plan.id}">${escapeHtml(plan.name)} · ${formatPrice(plan.price)}</option>`
        )
        .join('');
    };

    const getActiveGalleryIndex = () => {
      const activeIndex = galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      return activeIndex === -1 ? 0 : activeIndex;
    };

    let galleryAutoplayTimer = null;
    let galleryAutoplayDelayTimer = null;

    const stopGalleryAutoplay = () => {
      if (galleryAutoplayTimer) {
        window.clearInterval(galleryAutoplayTimer);
        galleryAutoplayTimer = null;
      }
      if (galleryAutoplayDelayTimer) {
        window.clearTimeout(galleryAutoplayDelayTimer);
        galleryAutoplayDelayTimer = null;
      }
    };

    const startGalleryAutoplay = (delayMs) => {
      if (!elements.gallery || galleryThumbs.length < 2 || elements.gallery.dataset.zaisGalleryAutoplay !== 'true') {
        return;
      }
      const activeThumb = galleryThumbs[getActiveGalleryIndex()];
      if (activeThumb?.dataset.mediaType === 'video') return;

      stopGalleryAutoplay();

      const intervalSeconds = Number(elements.gallery.dataset.zaisGalleryAutoplayInterval || 4);
      const intervalMs = Math.max(2, intervalSeconds) * 1000;
      const initialDelaySeconds = Number(elements.gallery.dataset.zaisGalleryInitialDelay || 12);
      const resolvedDelayMs = Number.isFinite(delayMs)
        ? delayMs
        : Math.max(12, initialDelaySeconds) * 1000;

      galleryAutoplayDelayTimer = window.setTimeout(() => {
        galleryAutoplayDelayTimer = null;
        if (document.hidden) return;
        const nextThumb = moveGallery(1, { scrollThumb: false });
        if (nextThumb?.dataset.mediaType === 'video') return;

        galleryAutoplayTimer = window.setInterval(() => {
          const dialog = elements.gallery.querySelector('[data-zais-gallery-dialog]');
          if (document.hidden || dialog?.open) return;
          const nextIntervalThumb = moveGallery(1, { scrollThumb: false });
          if (nextIntervalThumb?.dataset.mediaType === 'video') {
            stopGalleryAutoplay();
          }
        }, intervalMs);
      }, resolvedDelayMs);
    };

    const restartGalleryAutoplay = () => {
      stopGalleryAutoplay();
      const intervalSeconds = Number(elements.gallery?.dataset.zaisGalleryAutoplayInterval || 4);
      startGalleryAutoplay(Math.max(2, intervalSeconds) * 1000);
    };

    const setGalleryImage = (imageElement, image, alt, options = {}) => {
      if (!imageElement || !image) return;

      const applySource = () => {
        imageElement.srcset = options.srcset || '';
        if (options.sizes) imageElement.sizes = options.sizes;
        imageElement.src = image;
      };

      const currentUrl = imageElement.currentSrc || imageElement.src;
      if (currentUrl === image || imageElement.src === image) {
        if (alt) imageElement.alt = alt;
        return;
      }

      if (options.transition === false) {
        applySource();
        if (alt) imageElement.alt = alt;
        return;
      }

      const preload = new Image();
      preload.srcset = options.srcset || '';
      if (options.sizes) preload.sizes = options.sizes;

      preload.onload = () => {
        imageElement.classList.add('is-transitioning');

        window.setTimeout(() => {
          applySource();
          if (alt) imageElement.alt = alt;

          window.requestAnimationFrame(() => {
            imageElement.classList.remove('is-transitioning');
          });
        }, 180);
      };

      preload.onerror = () => {
        applySource();
        if (alt) imageElement.alt = alt;
        imageElement.classList.remove('is-transitioning');
      };

      preload.src = image;
    };

    const updateGallery = ({ mediaId, image, srcset, sizes, alt, mediaType = 'image', videoSrc }, options = {}) => {
      if (!elements.gallery || (!image && !videoSrc)) return;

      const mainImage = elements.gallery.querySelector('[data-zais-gallery-main]');
      const galleryVideo = elements.gallery.querySelector('[data-zais-gallery-video]');
      const zoomButton = elements.gallery.querySelector('[data-zais-gallery-open]');
      const dialogImage = elements.gallery.querySelector('[data-zais-gallery-dialog-image]');
      const dialog = elements.gallery.querySelector('[data-zais-gallery-dialog]');
      const isVideo = mediaType === 'video' && Boolean(videoSrc);
      let activeThumb = null;

      if (isVideo) {
        stopGalleryAutoplay();
        if (mainImage) mainImage.hidden = true;
        if (zoomButton) zoomButton.hidden = true;
        if (galleryVideo) {
          galleryVideo.hidden = false;
          galleryVideo.poster = image || '';
          galleryVideo.defaultMuted = true;
          galleryVideo.muted = true;
          galleryVideo.loop = false;
          if (galleryVideo.getAttribute('src') !== videoSrc) {
            galleryVideo.src = videoSrc;
            galleryVideo.load();
          } else if (galleryVideo.ended) {
            galleryVideo.currentTime = 0;
          }
          const playPromise = galleryVideo.play();
          if (playPromise) playPromise.catch(() => {});
        }
        if (dialog?.open) dialog.close();
      } else {
        if (galleryVideo) {
          galleryVideo.pause();
          galleryVideo.hidden = true;
        }
        if (mainImage) mainImage.hidden = false;
        if (zoomButton) zoomButton.hidden = false;
      }

      if (mainImage && !isVideo) {
        setGalleryImage(mainImage, image, alt || mainImage.alt, { ...options, srcset, sizes });
      }

      if (dialogImage) {
        const activeThumb = galleryThumbs.find((thumb) => String(thumb.dataset.mediaId) === String(mediaId));
        dialogImage.dataset.image = activeThumb?.dataset.imageLarge || image;
        dialogImage.alt = alt || dialogImage.alt;
        if (dialogImage.closest('[data-zais-gallery-dialog]')?.open) {
          dialogImage.src = dialogImage.dataset.image;
        }
      }

      galleryThumbs.forEach((thumb) => {
        const isActive = String(thumb.dataset.mediaId) === String(mediaId);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) activeThumb = thumb;
      });

      if (activeThumb && options.scrollThumb !== false) {
        const thumbList = activeThumb.parentElement;
        if (thumbList) {
          const targetLeft = activeThumb.offsetLeft - (thumbList.clientWidth - activeThumb.clientWidth) / 2;
          thumbList.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        }
      }
    };

    const moveGallery = (direction, options = {}) => {
      if (!galleryThumbs.length) return;

      const currentIndex = getActiveGalleryIndex();
      const nextIndex = (currentIndex + direction + galleryThumbs.length) % galleryThumbs.length;
      const nextThumb = galleryThumbs[nextIndex];

      updateGallery({
        mediaId: nextThumb.dataset.mediaId,
        image: nextThumb.dataset.image,
        srcset: nextThumb.dataset.imageSrcset,
        sizes: nextThumb.dataset.imageSizes,
        alt: nextThumb.dataset.alt,
        mediaType: nextThumb.dataset.mediaType,
        videoSrc: nextThumb.dataset.videoSrc,
      }, options);
      return nextThumb;
    };

    const render = (options = {}) => {
      const variant = variantMap.get(String(state.variantId));
      if (!variant) return;

      populateSellingPlans(variant);
      const activePlan = getActiveSellingPlan(variant);
      const currentPrice = activePlan ? activePlan.price : variant.price;
      const originalPrice = activePlan ? activePlan.compareAt : variant.compareAtPrice;

      if (elements.variantInput) {
        elements.variantInput.value = variant.id;
      }

      if (elements.sizeLabel) {
        elements.sizeLabel.textContent = getVariantDisplayTitle(variant);
      }

      if (options.updateGallery && variant.featuredImage) {
        updateGallery({
          mediaId: variant.featuredMediaId,
          image: variant.featuredImage,
          alt: variant.title,
        });
      }

      variantButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.variantId === String(variant.id));
      });

      if (elements.priceCurrent) elements.priceCurrent.textContent = formatPrice(currentPrice);

      const saveAmount = originalPrice && originalPrice > currentPrice ? originalPrice - currentPrice : 0;

      if (elements.priceOriginal) {
        elements.priceOriginal.textContent = saveAmount ? formatPrice(originalPrice) : '';
        elements.priceOriginal.hidden = !saveAmount;
      }

      if (elements.priceSave) {
        elements.priceSave.textContent = saveAmount ? `Save ${formatPrice(saveAmount)}` : '';
        elements.priceSave.hidden = !saveAmount;
      }

      if (elements.priceNote) {
        elements.priceNote.textContent = currentPrice >= 1500
          ? 'Free shipping'
          : (data.shippingThresholdText || data.shippingText);
      }

      if (elements.subscriptionCopy) {
        elements.subscriptionCopy.hidden = !activePlan;
      }

    };

    purchaseButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.purchaseType = button.dataset.purchaseType;
        updatePurchaseButtons();
        render();
      });
    });

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.variantId = button.dataset.variantId;
        render();
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        updateGallery({
          mediaId: thumb.dataset.mediaId,
          image: thumb.dataset.image,
          srcset: thumb.dataset.imageSrcset,
          sizes: thumb.dataset.imageSizes,
          alt: thumb.dataset.alt,
          mediaType: thumb.dataset.mediaType,
          videoSrc: thumb.dataset.videoSrc,
        });
        if (thumb.dataset.mediaType === 'video') {
          stopGalleryAutoplay();
        } else {
          restartGalleryAutoplay();
        }
      });
    });

    galleryPreviousButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextThumb = moveGallery(-1);
        if (nextThumb?.dataset.mediaType === 'video') stopGalleryAutoplay();
        else restartGalleryAutoplay();
      });
    });

    galleryNextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextThumb = moveGallery(1);
        if (nextThumb?.dataset.mediaType === 'video') stopGalleryAutoplay();
        else restartGalleryAutoplay();
      });
    });

    const galleryVideoPlayer = elements.gallery?.querySelector('[data-zais-gallery-video]');
    if (galleryVideoPlayer) {
      galleryVideoPlayer.loop = false;
      galleryVideoPlayer.addEventListener('pause', () => {
        if (!galleryVideoPlayer.ended && !galleryVideoPlayer.hidden) {
          stopGalleryAutoplay();
        }
      });
      galleryVideoPlayer.addEventListener('ended', () => {
        if (galleryVideoPlayer.hidden) return;
        const nextThumb = moveGallery(1, { scrollThumb: false });
        if (nextThumb?.dataset.mediaType === 'video') stopGalleryAutoplay();
        else restartGalleryAutoplay();
      });
    }

    root.querySelectorAll('[data-zais-gallery-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = elements.gallery?.querySelector('[data-zais-gallery-dialog]');
        if (!dialog) return;
        const dialogImage = dialog.querySelector('[data-zais-gallery-dialog-image]');
        const activeThumb = galleryThumbs.find((thumb) => thumb.classList.contains('is-active'));
        if (dialogImage) {
          dialogImage.src = activeThumb?.dataset.imageLarge || dialogImage.dataset.image || '';
          dialogImage.alt = activeThumb?.dataset.alt || dialogImage.alt;
        }
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });

    root.querySelectorAll('[data-zais-gallery-close]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = button.closest('[data-zais-gallery-dialog]');
        if (!dialog) return;
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      });
    });

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => updateTabs(button.dataset.zaisFunnelTabButton));
    });

    root.querySelectorAll('[data-zais-funnel-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!elements.quantityInput) return;
        const currentValue = Number(elements.quantityInput.value || 1);
        const delta = Number(button.dataset.zaisFunnelQty);
        const nextValue = Math.max(1, currentValue + delta);
        elements.quantityInput.value = String(nextValue);
      });
    });

    root.querySelectorAll('[data-zais-funnel-submit]').forEach((button) => {
      button.addEventListener('click', () => {
        elements.form?.requestSubmit();
      });
    });

    if (elements.sellingPlanSelect) {
      elements.sellingPlanSelect.addEventListener('change', render);
    }

    updatePurchaseButtons();
    updateTabs(tabButtons[0]?.dataset.zaisFunnelTabButton);
    render();
    startGalleryAutoplay();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopGalleryAutoplay();
      } else {
        startGalleryAutoplay();
      }
    });
  });
}

function deferZaisFunnelFaq() {
  const faqRoots = [...document.querySelectorAll('[data-zais-funnel-faq]')];
  if (!faqRoots.length) return;

  if (!('IntersectionObserver' in window)) {
    faqRoots.forEach(initZaisFunnelFaq);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      initZaisFunnelFaq(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' });

  faqRoots.forEach((faqRoot) => observer.observe(faqRoot));
}

function initZaisFunnelFaq(faqRoot) {
  if (!faqRoot || faqRoot.dataset.zaisFunnelFaqInitialized === 'true') return;
  faqRoot.dataset.zaisFunnelFaqInitialized = 'true';

  faqRoot.querySelectorAll('[data-zais-funnel-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('.zais-funnel-faq__item')?.classList.toggle('is-open');
    });
  });
}

function formatMoney(cents) {
  const amount = Number(cents || 0) / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

function escapeHtml(value) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}
